const tabs = [
  {
    key: 'brother',
    value: '邀请小哥'
  },
  {
    key: 'driver',
    value: '邀请司机'
  },
  {
    key: 'user',
    value: '邀请用户'
  }
];
const advertising = [
  {
    randomId: 9009699607191378,
    content: '185****3076获得12.0元奖励',
    type: 1
  },
  {
    randomId: 9007442990490449,
    content: '188****3397获得12.0元奖励',
    type: 1
  },
  {
    randomId: 8907476353690794,
    content: '132****3055获得12.0元奖励',
    type: 1
  },
  {
    randomId: 8907476353690794,
    content: 'ashdahsdjashdkjashkjdhsk',
    type: 1
  }
];
const commonActData = {
  id: 'cf0a41b5a0544385a3aa56d077995835', // 活动id
  name: '邀请活动', //活动名称
  type: 1, // 活动类型 0抽奖活动 1PK类活动 2邀请好友
  userType: 1, // 邀请者用户类型
  businessLine: 1, // 邀请者业务线
  category: 5, // 模板类别，5 邀请用户，6 邀请司机，7 邀请搬家小哥
  endTime: 1606794373067, // 结束时间
  startTime: 1606794373067, // 开始时间
  currentTime: 1606794373067, // 当前时间
  status: 1, // 活动状态 参考枚举定义
  isFirst: true, // 是否首次进入活动
  metaInfo: {}, // 模板页元数据定义，json格式，前端解析使用
  activityRule: 'xxxx', // 活动规则描述信息
  shareTitle: '翻牌子活动分享', // 分享标题配置
  shareContent: '零零落落', // 分享文案内容
  takeCashType: 0, //提现类型 0 提现到微信零钱 1提现到用户钱包
  taskCashLimit: 500, //提现金额限制 单位分
  cashStartTime: 1614182400000, //提现开始时间
  cashEndTime: 1614182400000, //提现结束时间
  shareUrl:
    'https://oimg-stg.huolala.cn/stone/stg/2021-03-25/e689dae0-9002-f895-4eed-703e54c3ab30.png', // 分享图片url
  message: advertising,
  taskInfos: [
    // 活动下邀请任务列表
    {
      userType: 1, // 受邀者用户类型
      businessLine: 1, // 邀请者业务线
      taskName: '任务一标题最多12字多12字任务一标题最多12字多12字',
      startTime: 1619280000000, //任务开始时间
      endTime: 1619366399000, // 任务结束时间
      currentTime: 1606794373067, // 当前时间
      status: 0, // 任务上下线状态 0 下线 1上线
      taskCode: 'invite_friends_register', // 任务枚举code
      priority: 0, // 任务展示优先级, 后端排序，前端无需处理
      relativeTime: 7, // 任务相对有效期的时间值，比如7天，该字段为7
      relativeTimeUnit: 0, // 任务有效期相对时间单位：0:天 1:周 2:月
      peopleGroupRelations: [
        // 任务关联的受邀者人群详情
        {
          peopleGroupId: '1', // 人群id
          conditions: [
            // 人群详情条件
            {
              type: 3, // 人群类别定义 1 城市，2 大数据标签，3 实时标签
              contents: [
                {
                  id: 4,
                  code: 'NOT_COMPLETE_FIRST_ORDER_VAN',
                  name: '未完成货运首单'
                }
              ]
            },
            {
              type: 1, // 人群类别定义 1 城市，2 大数据标签，3 实时标签
              contents: [
                {
                  id: 3,
                  code: '1006',
                  name: '上海市'
                },
                {
                  id: 2,
                  code: '1001',
                  name: '广州市'
                }
              ]
            }
          ],
          relation: 1 // 两个条件之间的关系，0-且 1-或
        }
      ],
      rewards: [
        // 完成任务可以获取到的奖励
        {
          name: '10-100元大礼包', // 当奖池配置随机抽奖时，只有奖励价值区间x1-x2元大礼包
          rewardType: 'REWARD_PACKAGE' // 奖品类型
        },
        {
          name: '1.08元现金',
          rewardType: 'RED_PACKET', // 奖品类型
          amount: 108, // 奖品价值，单位是分
          number: 1
        },
        {
          name: '5元优惠券',
          rewardType: 'COUPON', // 奖品类型
          amount: 500, // 奖品价值，单位是分
          number: 1 // 单次下发数量
        }
      ],
      supportBusinessLines: [4], // 任务支持的业务线类型
      taskId: '77afdb30e4a81e2b9cbb0d2989316e54' // 任务id
    },
    {
      userType: 1, // 受邀者用户类型
      businessLine: 1, // 邀请者业务线
      taskName: '任务一标题最多12字多12字任务一标题最多12字多12字',
      startTime: 1619280000000, //任务开始时间
      endTime: 1619366399000, // 任务结束时间
      currentTime: 1606794373067, // 当前时间
      status: 0, // 任务上下线状态 0 下线 1上线
      taskCode: 'invite_friends_register', // 任务枚举code
      priority: 0, // 任务展示优先级, 后端排序，前端无需处理
      relativeTime: 7, // 任务相对有效期的时间值，比如7天，该字段为7
      relativeTimeUnit: 0, // 任务有效期相对时间单位：0:天 1:周 2:月
      peopleGroupRelations: [
        // 任务关联的受邀者人群详情
        {
          peopleGroupId: '1', // 人群id
          conditions: [
            // 人群详情条件
            {
              type: 3, // 人群类别定义 1 城市，2 大数据标签，3 实时标签
              contents: [
                {
                  id: 4,
                  code: 'NOT_COMPLETE_FIRST_ORDER_VAN',
                  name: '未完成货运首单'
                }
              ]
            },
            {
              type: 1, // 人群类别定义 1 城市，2 大数据标签，3 实时标签
              contents: [
                {
                  id: 3,
                  code: '1006',
                  name: '上海市'
                },
                {
                  id: 2,
                  code: '1001',
                  name: '广州市'
                }
              ]
            }
          ],
          relation: 1 // 两个条件之间的关系，0-且 1-或
        }
      ],
      rewards: [
        // 完成任务可以获取到的奖励
        {
          name: '20天', // 当奖池配置随机抽奖时，只有奖励价值区间x1-x2元大礼包
          rewardType: 'MEMBER' // 奖品类型
        },
        {
          name: '1.08元现金',
          rewardType: 'RED_PACKET', // 奖品类型
          amount: 108, // 奖品价值，单位是分
          number: 1
        },
        {
          name: '5元优惠券',
          rewardType: 'COUPON', // 奖品类型
          amount: 500, // 奖品价值，单位是分
          number: 1 // 单次下发数量
        }
      ],
      supportBusinessLines: [4], // 任务支持的业务线类型
      taskId: '77afdb30e4a81e2b9cbb0d2989316e54' // 任务id
    }
  ],
  invitationInfos: {
    // 当前用户邀请的统计
    totalCurrency: 4000, // 当前用户在该邀请好友活动下总获取现金
    completeInviteTasks: 50, // 完成的邀请任务个数
    inprogressInvite: 10, // 正在进行任务的受邀者个数
    invitees: [
      // 所有受邀者状态信息
      {
        inviteeCellPhone: '132xxxx1234', // 受邀者信息
        inviteeUserId: '1234567', // 受邀者id
        status: '0', // 邀请状态 0进行中，1已完成，2已过期
        createdAt: 1619366399000 // 邀请关系建立时间
      }
    ]
  },
  maxRewardAmount: 80000
};

const inviteInfos = {
  // 当前用户邀请的统计
  totalCurrency: 4000, // 当前用户在该邀请好友活动下总获取现金
  completeInviteTasks: 50, // 完成的邀请任务个数
  inprogressInvite: 10, // 正在进行任务的受邀者个数
  invitees: [
    // 所有受邀者状态信息
    {
      inviteeCellPhone: '132xxxx1234', // 受邀者信息
      inviteeUserId: '1234567', // 受邀者id
      status: '0', // 邀请状态 0进行中，1已完成，2已过期
      createdAt: 1619366399000, // 邀请关系建立时间
      taskInfos: [
        {
          taskName: '邀请好友注册1',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        },
        {
          taskName: '邀请好友注册2',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        },
        {
          taskName: '邀请好友注册3',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        }
      ]
    },
    {
      inviteeCellPhone: '132xxxx1234', // 受邀者信息
      inviteeUserId: '123456712312', // 受邀者id
      status: '0', // 邀请状态 0进行中，1已完成，2已过期
      createdAt: 1619366399000, // 邀请关系建立时间
      taskInfos: [
        {
          taskName: '邀请好友注册7',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        },
        {
          taskName: '邀请好友注册8',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        },
        {
          taskName: '邀请好友注册9',
          status: 0, // 任务完成状态 0进行中，1已完成，2已过期
          endTime: 1619366399000, // 任务结束时间
          resultDesc: '' // 任务失败原因描述
        }
      ]
    }
  ]
};
const LAYOUT_TYPE = {
  flow: 'flow',
  position: 'position'
};
const COMPONENT_NAME = {};
const BUSINESS_TYPE_XL = 8; // 业务线 2 搬家 3 货运大货车 4 货运小B 5:零担物流 6 企业 8 小拉;
const CityLocation = {
  id: 'odcw99111',
  componentTypeId: 2088, // 组件类型 id
  componentTypeName: '城市组件', // 组件类型名称
  layoutType: 'position', // LAYOUT_TYPE
  componentDetail: {
    verticalDirection: 'top', // 固定为 top
    verticalDistance: 50,
    horizontalDirection: 'left',
    horizontalDistance: 26
  }
};
const RESULT_TEXT = {
  NoTaskExcute: '暂无任务',
  CityCheckBlocked: '当前城市暂未开启活动，快去看看别的活动吧',
  PersonaCheckBlocked: '暂时无法参与，去看看别的活动吧',
  ConditionCheckBlocked: '暂时无法参与，去看看别的活动吧',
  ActivityIsOver: '活动已结束',
  ActivityHasNotStarted: '活动未开始',
  ActivityIsOffline: '活动已下线'
};
export {
  tabs,
  LAYOUT_TYPE,
  commonActData,
  advertising,
  COMPONENT_NAME,
  inviteInfos,
  BUSINESS_TYPE_XL,
  CityLocation,
  RESULT_TEXT
};
